// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';
import {Container} from 'react-bootstrap';

const StyledContainer = styled(Container)`
  background-image: url('/assets/ui/container-main-bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff;
  width: 100%;
  padding-right: 1.75rem;
  padding-left: 1.75rem;
  padding-bottom: 1.75rem;
  margin-right: auto;
  margin-left: auto;
  min-height: 360px;
`;

const PageContentComponent = ({children}) => {
  return <StyledContainer>{children}</StyledContainer>;
};

export default PageContentComponent;
